import {
  fadeSlideIn,
  SideOverHeader,
  SideOverHeading,
  SideOverDescription,
  ElementsButton,
  Account,
} from '@elements-financial/elements';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { displayAccountType } from '../../util';

type MergeAccountsIndexPageProps = {
  account: Account | null | undefined;
  sourceAccountID: string | undefined;
  children?: React.ReactNode;
  onClick: () => void;
  exitRoute?: string;
};

export const MergeAccountsIndexPage = ({
  account,
  sourceAccountID,
  children,
  onClick,
  exitRoute,
}: MergeAccountsIndexPageProps) => {
  const { t: tLoan } = useTranslation('loan');
  const { t: tCommon } = useTranslation('common');
  const { t: tInvestment } = useTranslation('investment');
  const { t: tRealEstate } = useTranslation('realEstate');
  const { t: tCashAccount } = useTranslation('cashAccount');

  return (
    <>
      <SideOverHeader exit={exitRoute} />
      <SideOverHeading heading={tCommon('merge-account-heading')} className="!mt-4" />
      {account && (
        <>
          <SideOverDescription
            description={tCommon('merge-account-description', {
              accountType: displayAccountType(
                account,
                tLoan,
                tCashAccount,
                tCommon,
                tInvestment,
                tRealEstate
              ).toLowerCase(),
              accountName: account.name,
            })}
          />
          <motion.div {...fadeSlideIn()}>
            {children}

            <ElementsButton
              className="mt-20"
              size="large"
              disabled={!sourceAccountID}
              onClick={onClick}
              label={tCommon('merge-account-button')}
            />
          </motion.div>
        </>
      )}
    </>
  );
};
